/**
 * Re-exports product-analysis metric catalog from domain/adebify/metrics.js.
 */
export {
  PRODUCT_ANALYSIS_METRICS,
  PRODUCT_ANALYSIS_METRIC_KEYS,
  PRODUCT_ANALYSIS_DEFAULT_METRICS,
  PRODUCT_ANALYSIS_AD_METRIC_KEYS,
} from 'domain/adebify/metrics';
